import React from "react";

const headerSkeleton = () => (
	<div
		className='boxed-1600 ss-section header-hero header-hero__skeleton'
		role='status'
		aria-live='polite'
	>
		<div className='container header-hero__root-content '>
			<h2 className='h2-bigger header-hero__form-title'>
				Finde deinen nächsten Job
			</h2>
			<form className='c-form-inputs'>
				<input
					type='text'
					className='c-form-inputs__text-search c-form-inputs__text-search--keyword'
					aria-label=''
					placeholder='Jobtitel, Jobtyp oder Unternehmen'
					restattributes='[object Object]'
					defaultValue=''
					disabled=''
				/>
				<div className='c-form-inputs__location-group '>
					<input
						type='text'
						className='c-form-inputs__text-search'
						aria-label=''
						placeholder='Standort'
						restattributes='[object Object]'
						defaultValue=''
						disabled=''
					/>
					<select
						className='c-form-inputs__radius d-none'
						selectrestattribute='[object Object]'
					>
						<option value='' selected=''>
							Radius
						</option>
						<option value={1}>1 km</option>
						<option value={10}>10 km</option>
						<option value={20}>20 km</option>
						<option value={30}>30 km</option>
						<option value={40}>40 km</option>
						<option value={50}>50 km</option>
					</select>
				</div>
				<button
					className='ss-button ss-button--large ss-button--green c-form-inputs__submit-button'
					restattributes='[object Object]'
					type='button'
				>
					Jobs finden
				</button>
			</form>
			<div className='popular-tags'>
				<h2 className='ss-copy-default popular-tags__title'>Beliebte Suchen</h2>
				<div className='popular-tags__list'>
					<button className='popular-tags__item ' type='button'>
						Ausbildung
					</button>
					<button className='popular-tags__item ' type='button'>
						Werkstudent
					</button>
					<button className='popular-tags__item ' type='button'>
						Praktikum
					</button>
					<button className='popular-tags__item ' type='button'>
						Vollzeit
					</button>
					<button className='popular-tags__item ' type='button'>
						Teilzeit
					</button>
					<button className='popular-tags__item ' type='button'>
						Duales Studium
					</button>
				</div>
			</div>
		</div>
		<div className='header-hero__left-background-pattern'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width={353}
				height={368}
				fill='none'
				viewBox='0 0 353 368'
			>
				<g clipPath='url(#clip0_880_5011)'>
					<path
						fill='#8363E2'
						d='M282.781 309.348c-73.963 66.982-183.503 74.476-271.51 33.257-93.156-43.562-139.968-141.927-122.648-242.166C-94.993 5.821-20.093-81.302 75.872-99.101c12.639-2.343 25.278-.938 36.045 3.746 92.688-18.267 188.653 51.057 224.23 142.396 33.705 87.123 17.321 198.135-53.366 262.307zM237.842 80.766c-7.958-21.078-25.747-44.967-44.004-57.614-19.661-13.115-57.579-28.573-79.58-11.242-17.789 14.053-40.727 19.673-59.92 9.837-37.45 24.825-63.196 67.45-66.005 111.949-3.277 55.272 27.62 101.175 77.24 119.912 51.962 20.141 111.881 14.989 150.267-24.357 37.45-37.473 41.195-98.834 22.002-148.485z'
					/>
					<path
						fill='#1478C8'
						d='M273.63-10.048c-5.994-13.715-24.236-22.683-38.047-15.298-53.162 28.221-100.07 67.52-129.778 121.06-31.011 55.652-38.047 122.644-15.897 182.778 13.03 35.343 66.192 11.869 53.162-23.473-34.92-94.95 36.745-184.888 115.706-226.56 13.812-7.121 21.369-23.21 14.854-38.507z'
					/>
				</g>
				<defs>
					<clipPath id='clip0_880_5011'>
						<rect width={353} height={368} fill='#fff' rx={12} />
					</clipPath>
				</defs>
			</svg>
		</div>
		<div className='header-hero__right-background-pattern'>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width={90}
				height={213}
				fill='none'
				viewBox='0 0 90 213'
			>
				<path
					fill='#FA3273'
					d='M52.119 1.739c-3.894 2.978-4.206 8.308-1.636 12.227C64.815 35.678 72.681 61.78 72.76 87.88c.078 27.277-9.269 53.143-26.949 73.836-12.072 14.108-26.949 25.474-42.214 35.82-9.269 6.271 1.246 20.144 10.514 13.874 28.195-19.125 54.91-42.797 67.372-75.56 10.593-27.747 10.827-58.395 3.35-86.926-4.284-16.225-11.294-31.51-20.563-45.54-2.648-3.919-8.645-4.389-12.15-1.645z'
				/>
			</svg>
		</div>
	</div>
);

export default headerSkeleton;
